import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router";
import { Table } from 'reactstrap';
import SiteInfoModal from './SiteInfoModal';
import Pagination from "../components/Pagination";
import moment from "moment";
import { sitePhpVersions, siteWordPressVersions } from "../services/constant";
import "../assets/css/Table.css";

const SiteListTable = ({ items, doDelete, doEdit, doHistory, doUpgrade, userRole }) => {
    const [localItems, setlocalItems] = useState([...items]);
    const [toggleSorting, setToggleSorting] = useState(0);
    const [dynamicStyles, setDynamicStyles] = useState();
    const [deployData, setDeployData] = useState('');

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const pageFromUrl = Number(params.get("page")) || 1;
        setCurrentPage(pageFromUrl);
    }, [location.search]);

    useEffect(() => {
        setlocalItems(items);
        const calculatedTotalPages = Math.ceil(items.length / pageSize);
        if (currentPage > calculatedTotalPages && calculatedTotalPages > 0) {
            setCurrentPage(1);
            navigate(`?page=1`, { replace: true });
        }
    }, [items, pageSize, currentPage, navigate]);

    const totalPages = Math.ceil(localItems.length / pageSize);
    const startIndex = (currentPage - 1) * pageSize;
    const visibleItems = localItems.slice(startIndex, startIndex + pageSize);

    const sortTable = (field) => {
        let sortedData = [];
        if (toggleSorting === 1) {
            sortedData = [...localItems].sort((a, b) => a[field] > b[field] ? 1 : -1);
            setToggleSorting(0);
        } else {
            sortedData = [...localItems].sort((a, b) => b[field] > a[field] ? 1 : -1);
            setToggleSorting(1);
        }
        setlocalItems(sortedData);
    }
    const showActions = userRole === 1;

    return (
        <div className="site-table-container" style={{ paddingBottom: "calc(40px + 2rem)"}}>
            <style>{dynamicStyles}</style>
            <Table className="table table-hover site-table" responsive hover>
                <thead>
                    <tr>
                        <th>Sr. No.</th>
                        <th onClick={() => sortTable("name")} className="cursor-pointer">Name</th>
                        <th onClick={() => sortTable("link")} className="cursor-pointer">Link</th>
                        <th onClick={() => sortTable("runningStatus")} className="cursor-pointer">Running Status</th>
                        <th onClick={() => sortTable("sslExpiry")} className="cursor-pointer">SSL Expiry</th>
                        <th onClick={() => sortTable("domainExpiry")} className="cursor-pointer">Domain Expiry</th>
                        <th onClick={() => sortTable("phpVersion")} className="cursor-pointer">PHP Version</th>
                        <th onClick={() => sortTable("wordPressVersion")} className="cursor-pointer">WordPress Version</th>
                        <th onClick={() => sortTable("contact")} className="cursor-pointer">Contact</th>
                        <th onClick={() => sortTable("comment")} className="cursor-pointer">Comment</th>
                        <th onClick={() => sortTable("lastUpdated")} className="cursor-pointer">Last Updated Time</th>
                        <th onClick={() => sortTable("status")} className="cursor-pointer">Site Status</th>
                        {showActions && <th>Actions</th>}
                    </tr>
                </thead>
                <tbody>
                    {visibleItems.map((item, index) => (
                        <tr key={item._id}>
                            <td>{item.originalSrNo || startIndex + index + 1}</td>
                            <td>{item.name || '-'}</td>
                            <td className="link-cell">
                                {item.link ? (
                                    <a href={item.link} target="_blank" rel="noopener noreferrer" title={item.link}>
                                        {(() => {
                                            try {
                                                return new URL(item.link).hostname;
                                            } catch (e) {
                                                return item.link;
                                            }
                                        })()}
                                    </a>
                                ) : "-"}
                            </td>
                            <td>
                                {item.runningStatus === true ? (
                                    <span className="text-success">SUCCESS</span>
                                ) : item.runningStatus === false ? (
                                    <span className="text-danger">ERROR</span>
                                ) : "-"}
                            </td>
                            <td>{item.sslExpiry && item.sslExpiry !== 'NO_CERT_INFO' ? moment(item.sslExpiry).format("DD/MM/YYYY") : "-"}</td>
                            <td>{item.domainExpiry ? moment(item.domainExpiry).format('DD/MM/YYYY') : '-'}</td>
                            <td>{sitePhpVersions.find(v => v.value === String(item.phpVersion))?.name || '-'}</td>
                            <td>{siteWordPressVersions.find(v => v.value === String(item.wordPressVersion))?.name || '-'}</td>
                            <td>{item.contact || "-"}</td>
                            <td>{item.comment || "-"}</td>
                            <td>{item.lastUpdated ? moment(item.lastUpdated).format("DD/MM/YYYY HH:mm") : "-"}</td>
                            <td>{item.status === true ? <span className="text-success">Active</span> : item.status === false ? <span className="text-danger">Inactive</span> : '-'}</td>
                            {showActions && (
                                <td className="text-center">
                                    <div className="d-flex justify-content-center align-items-center action-icons">
                                        <i className="fa-solid fa-clock-rotate-left text-warning" onClick={() => doHistory(item._id, currentPage)} title="History" role="button"></i>
                                        <i className="fas fa-edit text-primary" onClick={() => doEdit(item._id)} title="Edit" role="button"></i>
                                        <i className="fa-solid fa-trash-can text-danger" onClick={() => doDelete(item._id)} title="Delete" role="button"></i>
                                        <i className="fa-solid fa-ellipsis-v text-secondary" data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={() => setDeployData(item)} title="More" role="button"></i>
                                    </div>
                                </td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </Table>
            <SiteInfoModal deployData={deployData} />
            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                pageSize={pageSize}
                onPageChange={(page) => {
                    setCurrentPage(page);
                    navigate(`?page=${page}`);
                }}
                onPageSizeChange={(size) => {
                    setPageSize(size);
                    setCurrentPage(1);
                    navigate(`?page=1`);
                }}
            />

        </div>
    );
}

export default SiteListTable
